const extractTextNodes = (component) => {
  try {
    const queue = Array.isArray(component) ? [...component] : [component];
    let text = '';

    while (queue.length > 0) {
      const currentNode = queue.shift();

      if (!currentNode) continue;

      if (typeof currentNode === 'string') {
        text += currentNode;
        continue;
      }

      const { children } = currentNode.props;
      if (Array.isArray(children)) {
        children.forEach((child) => queue.push(child));
      } else if (typeof children === 'string') {
        text += children;
      }
    }

    return text;
  } catch (e) {
    return '';
  }
};

export const extractTextFromChildren = (children) => {
  if (typeof children === 'string') return children;
  return extractTextNodes(children);
};
